import { EditorOptions } from '../../interfaces/editor-option.interface';
import { BaseControlOption } from '../control-options/control-option.interface';
import { UiControl } from './ui-control.model';

export class EditorControl extends UiControl<string> {

  rows: number;
  useImageToolbar: boolean;
  editorOptions: EditorOptions;

  constructor(id: string, label: string, value: string, useImageToolbarBtn: boolean, ...options: EditorOptions[]) {
    super(id, label, value, useImageToolbarBtn, options);

    this.useImageToolbar = useImageToolbarBtn;
    this.className = "EditorControl";
  }

}
